const URL = {
  DOCUMENT_PDF_UPLOAD: 'Media/UploadPdf',
  DOCUMENT_AUDIO_UPLOAD: 'Media/UploadAudio',
}
export default URL
